export default {
    autoPlay: {
        type: Boolean,
        default: undefined
    }, 
    autoRepeat: {
        type: Boolean,
        default: undefined
    }, 
    forwardSeek: {
        type: Boolean,
        default: undefined
    }, 
    fullScreen: {
        type: Boolean,
        default: undefined
    }, 
    media: {
        type: Object,
        default: undefined
    }, 
    messages: {
        type: Object,
        default: undefined
    }, 
    mute: {
        type: Boolean,
        default: undefined
    }, 
    navigatable: {
        type: Boolean,
        default: undefined
    }, 
    volume: {
        type: Number,
        default: undefined
    }, 

    // Events
    end: Function, 
    pause: Function, 
    play: Function, 
    kendoReady: {
        type: Function,
        default: undefined
    },  
    timeChange: {
        type: Function,
        default: undefined
    },  
    volumeChange: Function
}


// WEBPACK FOOTER //
// ./packages/kendo-mediaplayer-vue-wrapper/src/KendoMediaPlayer/MediaPlayerProps.js